import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Footer() {
  return (
    <footer className="bg-brand-dark text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="col-span-1 md:col-span-2">
          <h2 className="text-3xl font-serif mb-6 tracking-widest">LUXE.</h2>
          <p className="text-gray-400 max-w-md mb-8 font-light leading-relaxed">
            Elevating your personal style with precision cuts, expert color, and luxurious treatments in a relaxing, premium environment.
          </p>
          <div className="flex space-x-4">
            <a href="#" className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-brand-accent hover:text-brand-accent transition-colors">
              <SafeIcon icon={FiIcons.FiInstagram} />
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-brand-accent hover:text-brand-accent transition-colors">
              <SafeIcon icon={FiIcons.FiFacebook} />
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-brand-accent hover:text-brand-accent transition-colors">
              <SafeIcon icon={FiIcons.FiTwitter} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest mb-6">Contact</h4>
          <ul className="space-y-4 text-gray-400 font-light">
            <li className="flex items-start space-x-3">
              <SafeIcon icon={FiIcons.FiMapPin} className="mt-1 flex-shrink-0" />
              <span>123 Elegance Avenue<br/>Beverly Hills, CA 90210</span>
            </li>
            <li className="flex items-center space-x-3">
              <SafeIcon icon={FiIcons.FiPhone} className="flex-shrink-0" />
              <span>(555) 123-4567</span>
            </li>
            <li className="flex items-center space-x-3">
              <SafeIcon icon={FiIcons.FiMail} className="flex-shrink-0" />
              <span>hello@luxesalon.com</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest mb-6">Hours</h4>
          <ul className="space-y-2 text-gray-400 font-light">
            <li className="flex justify-between"><span>Mon - Fri</span> <span>9am - 8pm</span></li>
            <li className="flex justify-between"><span>Saturday</span> <span>9am - 6pm</span></li>
            <li className="flex justify-between"><span>Sunday</span> <span>Closed</span></li>
          </ul>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm font-light">
        &copy; {new Date().getFullYear()} Luxe Premium Salon. All rights reserved.
      </div>
    </footer>
  );
}